import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FilterStore } from "../FilterStore";
import { CommunityEditStore } from "./CommunityEditStore";

export const CommunityStatusNames = {
  Active: "Active",
  Visible: "Inactive (Users Waiting)",
  Inactive: "Inactive (No User)",
};

export class CommunitiesStore {
  loading = false;

  edit: CommunityEditStore;

  filterStore: FilterStore;

  filter: any = {
    page: 0,
    size: 100,
    status: ["Active", "Visible"],
    keyword: "",
    // regionId: "",
    // divisionId: "",
    // period: [undefined, undefined],
  };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {});
    this.edit = new CommunityEditStore(this);
    this.filterStore = new FilterStore(this);
    this.filterStore.showPeriod = false;
    this.filterStore.showSearchBtn = false;
    this.filterStore.showResetBtn = false;
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  get items() {
    if (this.filter.status.length === 0) return this.data.items;

    return this.data.items.filter(
      (x: any) =>
        this.filter.status.includes(x.status) &&
        x.name.toLocaleLowerCase().includes(this.filter.keyword.toLocaleLowerCase())
    );
  }

  @action onSearch(history) {
    const query = new URLSearchParams({ ...this.filter, page: 0 });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const query = new URLSearchParams({ ...this.filter, page: page - 1, size: pageSize });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    const keyword = params.get("keyword") || "";
    const status = params.get("status") || "Active,Visible";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    this.filter = { page, size, keyword, status: status.split(",") };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    // const { keyword, status, page, size } = this.filter;
    // const filter: any = { keyword, active: status < 2, visible: status === 1, page, size };

    Api.community
      .communities({ size: 10000 })
      .then((res) => {
        runInAction(() => {
          let data = res.data.communities;
          // data.items = data.items.map((x) => {
          //   let status = ["Active", "Visible", "Inactive"].indexOf(x.status);
          //   console.log("xxx", x.status, ["Active", "Visible", "Inactive"].indexOf(x.status));
          //   return {
          //     ...x,
          //     status,
          //   };
          // });
          this.data = data;
          console.log("data", data);
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const communitiesStore = new CommunitiesStore();
